import { render, staticRenderFns } from "./TextArea.vue?vue&type=template&id=993d8f70&scoped=true&lang=pug&"
import script from "./TextArea.vue?vue&type=script&lang=coffee&"
export * from "./TextArea.vue?vue&type=script&lang=coffee&"
import style0 from "./TextArea.vue?vue&type=style&index=0&id=993d8f70&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "993d8f70",
  null
  
)

export default component.exports